<template>
    <div class="flex w-full">
        <div class="landing-page">
            <HtmlPage
                v-if="page"
                :page="page"
            />
        </div>
    </div>
</template>

<script>
    import HtmlPage from '@app/rawHtmlPages/components/HtmlPage';
    import {
        getRawHtmlPage,
        getRawIntroPageName,
    } from '@app/rawHtmlPages/services/rawHtmlPages';
    import { RouteName } from '@app/router/constants/RouteName';
    import { errorGuard } from '@utils/ErrorGuard';
    import { mapGetters } from 'vuex';

    export default {
        name: 'LandingPage',
        emits: ['markFirstVisit'],
        data() {
            return {
                page: null,
            };
        },
        created() {
            this.fetchPage();
        },
        computed: {
            ...mapGetters('data/authentication', [
                'user',
                'isReturningUserDevice',
            ]),
        },
        watch: {
            user(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.fetchPage();
                }
            },
            isReturningUserDevice(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.fetchPage();
                }
            },
        },
        methods: {
            async fetchPage() {
                await errorGuard(async () => {
                    this.page = await getRawHtmlPage(await getRawIntroPageName());
                }, {
                    onError: () => {
                        this.$router.push({ name: RouteName.App.Home });
                    },
                });
                this.$emit('markFirstVisit');
            },
        },
        components: {
            HtmlPage,
        },
    };
</script>
